// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3gnEc","topBottomGutter":"Layout_topBottomGutter__1K52v"};